import styled from "styled-components";
import { Card as BaseCard } from "../../../../Styles";

export const Card = styled(BaseCard)`
  flex: 1;
  padding: 0;

  h1 {
    padding: 26px 0 8px 22px;
    font-family: var(--font-primary);
    font-size: 16px;
    font-weight: 600;
    color: #0f123f;
  }

  .echarts-for-react {
    min-width: 430px;
    left: -16%;

    @media (max-width: 1200px) {
      min-width: auto;
    }
  }

  @media (max-width: 1200px) {
    margin-top: 14px;
    padding-bottom: 16px;
  }
`;

export const AlertContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding-bottom: 64px;

  span {
    font-size: 12px;
    color: #92959e;
    width: 160px;
    margin: 8px;
  }

  button {
    width: 100px;
  }
`;
